import React from 'react'
import FormVehiculos from './FormVehiculos';
import FormCoberturas from './FormAdicionales';
import FormDataCliente from './FormDataCliente';
import FormConfirmacion from './FormConfirmacion';
// import FinalPedido from './FinalPedido'
import { connect } from 'react-redux';
import { STEPS } from '../../redux/actions/PasosFormulario';

const PanelReservacion = ({ step }) => {
    
    switch (step) {
        case STEPS.VEHICULO:
            return <FormVehiculos />
            // return <FinalPedido />
        case STEPS.COBERTURAS:
            return <FormCoberturas />
        case STEPS.COTIZAR:
            return <FormDataCliente onSubmit={values => { }} />
        case STEPS.DATOS_CLIENTE:
            return <FormDataCliente onSubmit={values => { }} />
        case STEPS.CONFIRMACION:
            return <FormConfirmacion />
        default:
            return <FormVehiculos />
    }
}


export default connect(null, null)(PanelReservacion);
